import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LocalStorage } from 'ngx-store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService{
  @LocalStorage('isCaptchaSolved') isCaptchaSolved: any;
  @LocalStorage('redirectTo') redirectTo: any;
  constructor(
    private router: Router) {

  }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    //window.alert(this.isCaptchaSolved)

    if(this.isCaptchaSolved){
        this.isCaptchaSolved = false;
        return true;
    }
    else{
        this.router.navigate(['captcha']);
        this.redirectTo = state.url.toString();
        //window.alert(" Route: " +state.url.toString()+" Redirect: " +this.redirectTo);
        return false;
    }

  }

}
